import React,{Component} from 'react';
import { apisettigs } from '../../../src/settings.js';
import './mensagens.css';
import { Modal } from 'bootstrap';


class Mensagens extends Component{
    constructor(props) {        
        super(props);

        this.state = {
            show: false,  
            rqtype: null,
            rqid: null,
            msgs2: [],
            recipientsMessage: [],
            msgCpsIds: [],
            selectedMsg: null,
        };

        this.mdlNmsgSbnt = React.createRef();

    }


    showMsgs = (reqtype, reqid, fromCentral) => {
        this.setState({rqtype: reqtype});
        this.setState({rqid: reqid});
        this.setState({frmCtrlMsg: fromCentral});

        console.log(fromCentral)
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId"), rtype: reqtype, rid: reqid })
        };

        // pega os recipientes no circuito da solicitacao
        fetch(apisettigs.endpoints.messageRecipients, requestOptions)
        .then(response3 => response3.json())
        .then(data3 => {
            //console.log(data3);
            this.setState({recipientsMessage: data3});
            
            
            // pega as mensagens
            fetch(apisettigs.endpoints.messages2, requestOptions)
            .then(response2 => response2.json())
            .then(data2 => {
                //console.log(data2);
                this.setState({msgs2: data2});

                this.setState({show: true});
            })
        })
    }


    hideMsgs = () => {
        this.setState({show: false});
        this.setState({rqtype: null});
        this.setState({rqid: null});
        this.setState({msgs2: []});
        this.setState({selectedMsg: null});
        this.setState({msgCpsIds: []});
    }


    voltar = () => {
        if (this.state.rqtype === 'Solicitação' ){
            this.hideMsgs();
            this.props.showSolic();
        }
        else if(this.state.rqtype === 'Ordem' ){
            this.hideMsgs();
            this.props.showOrd();
        }

    }


    getPara = (msgId) =>{
        let retval = null;

        this.state.msgs2.forEach((data) => { 
            data.messageRecipients.forEach((data) =>{
                if (data.messageId === msgId){
                    if(data.principal === 'Y')
                        //console.log(data.recipientName)
                        retval = data.recipientName;
                }
            });
        });

        return(retval);
    }


    getCps = (msgId) =>{
        let retval = '';

        this.state.msgs2.forEach((data) => { 
            data.messageRecipients.forEach((data) =>{
                if (data.messageId === msgId){
                    if(data.principal === 'N') {
                        //console.log(data.recipientName)
                        if (retval.length < 1){
                            retval += data.recipientName 
                        }
                        else{
                            retval += ', ' + data.recipientName ;
                        }
                    }
                }
            });
        });

        return(retval);
    }


    checkMsgStats = (msgId) =>{
        let retval = '';

        this.state.msgs2.forEach((data1) => { 
            data1.messageRecipients.forEach((data2) =>{
                if (data2.messageId === msgId){
                    if(data2.recipientId === window.sessionStorage.getItem("userId")){
                        //user principal/is in copy
                        if (data2.answered === 'N'){
                            if(data2.msgRead === 'N'){
                                retval = <><div className='MsgBdgNew'>NOVA</div></>;
                            }
                            else{
                                retval = '';
                            }
                        }
                        else {
                            retval = <><div className='MsgBdgRespd'>Respondida</div></>;
                        }
                    }
                }
            });
        });

        return retval;
    }


    showMarkBtn = (msgId) => {
        let retval = '';

        this.state.msgs2.forEach((data1) => { 
            data1.messageRecipients.forEach((data2) =>{
                if (data2.messageId === msgId){
                    if(data2.recipientId === window.sessionStorage.getItem("userId")){
                        //user principal/is in copy
                        if (data2.answered === 'N'){
                            if(data2.msgRead === 'N'){
                                retval = <>Marcar como: <button type="button" className="btn btn-outline-info msgBtnMark" onClick={(e) => this.marcarMsg(e, data2.msgRcpntId, msgId) }>Lida</button></>
                            }
                            else{
                               retval = <>Marcar como: <button type="button" className="btn btn-outline-info msgBtnMark" onClick={(e) => this.marcarMsg(e, data2.msgRcpntId, msgId) }>Não Lida</button></>
                            }
                        }
                        else {
                            retval = '';
                        }
                    }
                }
            });
        });

        return retval;
    }


    showRespBtn(msgId){
        let retval = '';

        this.state.msgs2.forEach((data1) => { 
            data1.messageRecipients.forEach((data2) =>{
                if (data2.messageId === msgId){
                    if(data2.recipientId === window.sessionStorage.getItem("userId")){
                        //user principal/is in copy
                        if (data2.answered === 'N'){
                            retval = <>
                                <button type="button" className="btn btn-outline-secondary msgBtnRes" onClick={() => this.showRespMdl(msgId)}>Responder</button>
                            </>
                        }
                        else {
                            retval = '';
                        }
                    }
                }
            });
        });
        return retval;
    }


    marcarMsg = (e, msgrcpntid, msgId) => {
        let btn = e.target;

        if (btn.innerHTML === 'Lida'){
            // marcar como lida

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ 
                    userid: window.sessionStorage.getItem("userId"),
                    msgrecipientid : msgrcpntid,
                    mark: 'Y',
                })
            };

            fetch(apisettigs.endpoints.markMessage, requestOptions).then(response => response.json())
            .then(data => {
                //console.log(data);

                if (data.markResult === 'ok'){
                    //mudar botao 
                    btn.innerHTML = 'Não Lida';
                    //remover badge
                    document.getElementById('mBdg'+msgId).innerHTML = "";
                }
               
            })
            
        }
        else{
            // marcar como nao lida --> POST
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ 
                    userid: window.sessionStorage.getItem("userId"),
                    msgrecipientid : msgrcpntid,
                    mark: 'N',
                })
            };

            fetch(apisettigs.endpoints.markMessage, requestOptions).then(response => response.json())
            .then(data => {
                //console.log(data);
                if (data.markResult === 'ok'){
                    //mudar botao
                    btn.innerHTML = 'Lida';
                    //add badge
                    document.getElementById('mBdg'+msgId).innerHTML = "<div class='MsgBdgNew'>NOVA</div>";
                }
               
            })
            
        } 
    }


    showRespMdl = (msgId) => {
        let modalResMsg = Modal.getOrCreateInstance(document.getElementById('ModalResMsg'));
        modalResMsg.show();
        
        let reqid = '';
        let cpids = [];
        let msgRecipentId = '';
        let sender = '';

        this.state.msgs2.forEach((data1) => { 

            if (data1.messageId === msgId){
                reqid = data1.purreqId;
                sender = data1.senderId;
                
                data1.messageRecipients.forEach((data2) =>{

                    cpids.push(data2.recipientId);
                    
                    if(data2.recipientId === window.sessionStorage.getItem("userId")){
                        msgRecipentId = data2.msgRcpntId;
                    }

                });

            }
        });
       
        const selMsg = {
            messageId: msgId,
            rqId: reqid,
            rtype: this.state.rqtype,
            copyIds: cpids,
            msgrcpid: msgRecipentId,
            senderId: sender,
        }
        this.setState({selectedMsg: selMsg})

    }


    addRespMsg = () => {
        let msgtxt = document.getElementById('msgtxtmsg').value.trim();

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ 
                userid: window.sessionStorage.getItem("userId"),
                rid: this.state.selectedMsg.rqId,
                rtp: this.state.selectedMsg.rtype,
                msgid: this.state.selectedMsg.messageId,
                txtmsg: msgtxt,
                senderid: this.state.selectedMsg.senderId,
                cpids: this.state.selectedMsg.copyIds,
                msgrcptid: this.state.selectedMsg.msgrcpid,
            })
        };

        fetch(apisettigs.endpoints.addMessage, requestOptions).then(response => response.json())
        .then(data => {
            //console.log(data);
            let modalResMsg = Modal.getOrCreateInstance(document.getElementById('ModalResMsg'));
            modalResMsg.hide();

            if (data.addMsg === 'ok'){
                let modalResMsgOk = Modal.getOrCreateInstance(document.getElementById('ModalResMsgOk'));
                modalResMsgOk.show();
            }
            
        });
        //limpar o state.selectedMsg ?
    }


    refreshMsgs = () => {
        let modalResMsgOk = Modal.getOrCreateInstance(document.getElementById('ModalResMsgOk'));
        modalResMsgOk.hide();
        this.hideMsgs();
        this.showMsgs(this.state.rqtype, this.state.rqid)
    }

    showModalNewMsg = () => {
        let modalNewMsg = Modal.getOrCreateInstance(document.getElementById('ModalNewMsg'));
        
        let btnSend = this.mdlNmsgSbnt.current;
        btnSend.disabled = true;

        modalNewMsg.show();
    }


    addMsgCc = () => {
        let cpSel = document.getElementById('msgCps');

        let recptId = document.getElementById('msgRcpt').value;
        let cpId = document.getElementById('msgCps').value;
        let cpName = cpSel.options[cpSel.selectedIndex].text;

        if(recptId !== cpId && cpId !== ""){

            const newMsgCpsIds = [...this.state.msgCpsIds, {"id":cpId, "name":cpName}];

            this.setState({msgCpsIds: newMsgCpsIds});
            cpSel.options[cpSel.selectedIndex].remove();
        }
    }


    remMsgCc = (arridx) => {
        let cpMsgCpsIds = this.state.msgCpsIds;
    
        let cpSel = document.getElementById('msgCps');

        let opt = document.createElement('option');
        opt.value = cpMsgCpsIds[arridx].id;
        opt.innerHTML = cpMsgCpsIds[arridx].name;
        cpSel.appendChild(opt);

        cpMsgCpsIds.splice(arridx,1);
        this.setState({msgCpsIds: cpMsgCpsIds});

    }


    reloadMsgs = (reqtype, reqid) => {
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId"), rtype: reqtype, rid: reqid })
        };

        // pega mensagens da solicitacao
        fetch(apisettigs.endpoints.messages2, requestOptions).then(response2 => response2.json())
        .then(data2 => {
            //console.log(data2);
            this.setState({msgs2: data2});
        });
        
        
    }


    addNewMessage = (event) =>{

        let buttonEl = event.target;
        buttonEl.disabled = true;

        let msgtxt = document.getElementById('msgNewtxtmsg').value.trim();
        let msgRecipientId = document.getElementById("msgRcpt");
        let copyIds = [];

        this.state.msgCpsIds.forEach(cpPerson => copyIds.push(cpPerson.id));

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ 
                userid: window.sessionStorage.getItem("userId"),
                rid: this.state.rqid,
                rtp: this.state.rqtype,                
                txtmsg: msgtxt,
                msgrcptid: msgRecipientId.value,
                cpids: copyIds,
            })
        }; 

        let modalWntEl = document.getElementById('ModalWtng');
        let modalW = new Modal(modalWntEl);

        modalWntEl.addEventListener('hidden.bs.modal', () =>{
            //window.scrollTo(0,document.body.scrollHeight);
            window.scrollTo({ top: 0, behavior: 'smooth' });

        });

        modalWntEl.addEventListener('shown.bs.modal',() =>{
                
            fetch(apisettigs.endpoints.addNewMessage, requestOptions).then(response => response.json())
            .then(data => {
                //console.log(data);
                let modalW2 = Modal.getOrCreateInstance(modalWntEl);

                if (data.addMsg === 'ok')
                {
                    let modalNewMsg = Modal.getOrCreateInstance(document.getElementById('ModalNewMsg'));

                    modalW2.hide();

                    modalNewMsg.hide();

                    this.reloadMsgs(this.state.rqtype, this.state.rqid);

                    buttonEl.disabled = false;

                    document.getElementById('msgNewtxtmsg').value = '';

                }
                else{
                    modalW2.hide();
                }
    
            });

        });

        modalW.show();
    }

    mdlActiveSend = () => {
        let msgRecipientId = document.getElementById("msgRcpt");
        let btnSend = this.mdlNmsgSbnt.current;
        let msgtxt = document.getElementById('msgNewtxtmsg').value.trim();

        if (msgRecipientId.value !== "" && msgtxt.length > 0) {
            btnSend.disabled = false;
        }
        else{
            btnSend.disabled = true;
        } 

    }



    //#==>
    render(){
        if (this.state.show === true){
            return (
                <>
                    <div className='msgTopCont'>
                        Mensagens da {this.state.rqtype}
                    </div>

                    {this.state.msgs2.map((msgs2) => {
                        return(
                            <div className='container mt-2'>
                                <div className='row '>
                                    <div className='col- align-self-center colTitleMsg ' style={{width:'4rem'}}>
                                        Data:
                                    </div>
                                    <div className='col- align-self-center colTextMsg' style={{width:'10rem'}}>
                                        {msgs2.sendDate}
                                    </div>
                                </div>
                                <div className='row  d-flex'>
                                    <div className='col- align-self-center colTitleMsg ' style={{width:'4rem'}}>
                                        De:
                                    </div>
                                    <div className='col- align-self-center colTextMsg ' style={{maxWidth:'54%'}}>
                                        {msgs2.senderName} 
                                    </div>
                                    <div className='col-  MsgCnMarg ' id={ 'mBdg' + msgs2.messageId}>
                                        {this.checkMsgStats(msgs2.messageId)}
                                    </div>
                                </div>
                                <div className='row '>
                                    <div className='col- align-self-center colTitleMsg' style={{width:'4rem'}}>
                                        Para:
                                    </div>
                                    <div className='col- align-self-center colTextMsg' style={{maxWidth:'75%'}}>
                                        {this.getPara(msgs2.messageId)} 
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col- align-self-center colTitleMsg ' style={{width:'4rem'}}>
                                        Cc:
                                    </div>
                                    <div className='col- align-self-center colTextMsg ' style={{maxWidth:'75%'}}>
                                        {this.getCps(msgs2.messageId)}
                                    </div>
                                </div>
                                <div className='MsgSbT1'>
                                    Mensagem:
                                </div>
                                <div className='Msgmsg'>
                                    {msgs2.msgText}
                                </div>
                                <div>
                                    <div className='MsgSbT2'>
                                        {this.showMarkBtn(msgs2.messageId)}
                                    </div>                            
                                </div>
                                <div className='mt-4 text-center'>
                                    {this.showRespBtn(msgs2.messageId)}
                                </div>
                                <hr className='hLn'/>
                            </div>
                        );
                    })}
                    
                    <div className='container mt-4 mb-4 text-center'>
                        <button type="button" className="btn btn-outline-dark msgBtn1" onClick={this.showModalNewMsg}>Nova Mensagem</button>
                        <button type="button" className="btn btn-outline-primary msgBtn2" onClick={this.voltar} >Voltar</button>
                    </div>

                    <div className="modal fade" id="ModalResMsg" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered justify-content-center">
                             <div className="modal-content modalConfirmCnt">
                                <div className="modalConfirmHeader">
                                    Responder Mensagem
                                </div>
                                <div className="mt-2">
                                    <div className="d-flex justify-content-center mt-2">
                                        <textarea className='msgResTxA' maxLength="500" id="msgtxtmsg"></textarea>
                                    </div>
                                    <div className="mt-4 mb-4 d-flex justify-content-center">
                                        <button type="button" className="btn btn-outline-secondary msgMdlBtnCnl" data-bs-dismiss="modal">Cancelar</button>
                                        <button type="button" className="btn btn-outline-secondary msgMdlBtnCnl" onClick={this.addRespMsg}>Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="ModalResMsgOk" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered justify-content-center">
                             <div className="modal-content modalConfirmCnt">
                                <div className="modalConfirmHeader">
                                    Aviso
                                </div>
                                <div className="mt-2">
                                    <div className='colTextMsg text-center'>
                                        Mensagem Enviada <i className='fas fa-check fAsOk'></i>
                                    </div>
                                    <div className="mt-4 mb-4 d-flex justify-content-center">
                                        <button type="button" className="btn btn-outline-secondary msgMdlBtnCnl" onClick={this.refreshMsgs} >Voltar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="ModalNewMsg" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered justify-content-center">
                             <div className="modal-content modalConfirmCnt">
                                <div className="modalConfirmHeader">
                                    Nova Mensagem
                                </div>
                                <div className="container mt-2" >
                                    <div className='container' style={{'padding':'0'}}>
                                        <div className='d-inline-flex'>
                                            <div className='colNewTextMsg  d-flex'>
                                                Para:                                        
                                            </div>
                                            <div className='d-flex align-self-center'>
                                                <select className="form-select form-select-sm newTextMsgToSel" id='msgRcpt' onChange={this.mdlActiveSend}> 
                                                    <option value='' selected> </option>

                                                    {this.state.recipientsMessage.requester.id === '' ? null : <option value={this.state.recipientsMessage.requester.id}>{this.state.recipientsMessage.requester.name}</option>}

                                                    {this.state.recipientsMessage.approvers.map((data)=>{
                                                        return (<option value={data.id}> {data.name} </option>)
                                                    })}
                                                    
                                                </select>  
                                            </div> 
                                            

                                            <div className='colNewTextMsg  d-flex' style={{'margin-left': '1rem'}}>
                                                Ad.Cópia:                                        
                                            </div>
                                            <div className='d-flex align-self-center '>
                                                <select className="form-select form-select-sm newTextMsgToSel" id='msgCps' onChange={this.addMsgCc}>
                                                
                                                    <option value='' selected> </option>

                                                    {this.state.recipientsMessage.requester.id === '' ? null : <option value={this.state.recipientsMessage.requester.id}>{this.state.recipientsMessage.requester.name}</option>}

                                                    {this.state.recipientsMessage.approvers.map((data)=>{
                                                        return (<option value={data.id}> {data.name} </option>)
                                                    })}

                                                </select>
                                            </div>

                                        </div>
                                    </div>

                                    <div className='container' style={{'padding':'0'}}>
                                        <div className='d-inline-flex mt-1'>
                                            <div className='colNewTextMsg  d-flex'>
                                                Cc:                                        
                                            </div>
                                            <div className='colNewTexcctMsg' id='coplist' >
                                                {this.state.msgCpsIds.map((msgCpsIds, index) => { 
                                                    return(<div className="d-inline-flex" id={'cpsid' + msgCpsIds.id}> {msgCpsIds.name} &nbsp; <i className="fas fa-minus-circle" onClick={() => {this.remMsgCc(index)} }></i> &nbsp; </div>    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-center mt-2">
                                        <textarea className='msgResTxA' maxLength="500" id="msgNewtxtmsg" onChange={this.mdlActiveSend}></textarea>
                                    </div>

                                    <div className="mt-4 mb-4 d-flex justify-content-center">
                                        <button type="button" className="btn btn-outline-secondary msgMdlBtnCnl" data-bs-dismiss="modal">Cancelar</button>
                                        <button type="button" className="btn btn-outline-secondary msgMdlBtnCnl" onClick={this.addNewMessage} ref={this.mdlNmsgSbnt}  >Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal fade" id="ModalWtng" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content modalWtngContent">
                                <img className="centerWtngImg" src={apisettigs.serverUrl + 'static/images/loading.gif'} alt="" />
                            </div>
                        </div>
                    </div>




                </>       
            );  
        }
        else{
            return null;
            
        }
    }

}

export default Mensagens